import React, { Component } from 'react'
import { Container } from 'reactstrap'
import { MapContainer, TileLayer, GeoJSON, Marker, LayersControl, Popup } from 'react-leaflet'
import MarkerClusterGroup from 'react-leaflet-markercluster'
import * as utm from 'utm'
import Breadcrumbs from '../../../../../components/Common/Breadcrumb'
import { graphClient } from '../../../../../store/sagas/auth'
import { notifyError } from '../../../../../utils/notify'
import SETORES from './data/SETORES.json'
import LOGRADOUROS_SELECIONADOS from './data/LOGRADOUROS_SELECIONADOS.json'

export default class Map extends Component {
  constructor(props) {
    super(props)
    this.state = {
      points: null,
    }
  }

  async componentDidMount() {
    const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,b124d932-cf69-4fa0-b61a-4b738f3a8440'
    const listId = 'c23efe45-33ce-4f93-b7fb-e10c14877f61'

    try {
      const res = await graphClient
        .api(`/sites/${siteId}/lists/${listId}/items?top=10000&expand=fields($select=ID,Setor,Latitude,Longitude)`)
        .get()

      const points = res.value.map(item => ({
        fields: {
          ID: item.fields.id,
          Setor: item.fields.Setor,
          Longitude: item.fields.Longitude,
          Latitude: item.fields.Latitude,
        },
        coords: utm.toLatLon(item.fields.Latitude, item.fields.Longitude, 23, 'K'),
      }))

      console.tron.log('points', points)

      this.setState({ points })
    } catch (err) {
      notifyError(err)
    }
  }

  render() {
    const { points } = this.state

    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Inventário Arborização Riberião Preto"
            breadcrumbItems={[]}
          />

          <div style={{ marginTop: 12, width: '100%', height: 'calc(100vh - 285px)' }}>
            <MapContainer
              zoom={12}
              maxZoom={18}
              center={[-21.18, -47.8]}
              style={{
                width: '100%',
                height: '100%',
              }}
            >
              <LayersControl
                collapsed={false}
                position="topright"
              >
                <LayersControl.BaseLayer checked name="OpenStreetMap">
                  <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name="ESRI Satélite">
                  <TileLayer
                    attribution="&copy; ESRI"
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                  />
                </LayersControl.BaseLayer>
                {points?.length > 0 && (
                  <LayersControl.Overlay name="Indivíduos vegetais" checked>
                    <MarkerClusterGroup
                      spiderfyOnMaxZoom={false}
                      disableClusteringAtZoom={18}
                    >
                      {points.map(point => {
                        if (point.coords?.latitude && point.coords?.longitude) {
                          const keys = Object.keys(point.fields)
                          const values = Object.values(point.fields)

                          return (
                            <Marker
                              position={[
                                point.coords.latitude,
                                point.coords.longitude,
                              ]}
                            >
                              <Popup>
                                <h3>Indivíduo vegetal</h3>
                                <table>
                                  {keys.map((key, index) => (
                                    <tr>
                                      <th>{key}</th>
                                      <td>{values[index]}</td>
                                    </tr>
                                  ))}
                                </table>
                              </Popup>
                            </Marker>
                          )
                        }
                        return null
                      })}
                    </MarkerClusterGroup>
                  </LayersControl.Overlay>
                )}
                <LayersControl.Overlay name="Logradouros selecionados" checked>
                  <GeoJSON
                    data={LOGRADOUROS_SELECIONADOS}
                    pathOptions={{ color: '#ffea01' }}
                    /* onEachFeature={(feature, layer) => {
                      layer.bindPopup('teste')
                    }} */
                  />
                </LayersControl.Overlay>
                <LayersControl.Overlay name="Setores" checked>
                  <GeoJSON
                    data={SETORES}
                    pathOptions={{ color: '#01eaff', fillColor: 'transparent' }}
                  />
                </LayersControl.Overlay>
              </LayersControl>
            </MapContainer>
          </div>

        </Container>
      </div>
    )
  }
}
